// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"516":"ba601a07","600":"120cfa50"}[chunkId] + ".chunk.css";
};